module.exports = __webpack_public_path__ + "static/media/innovador.14ca0af8.svg";